import { useSelector } from 'react-redux';
import moment from 'moment';
import AvailabilityRequest from '../components/AvailabilityRequest';
import { RootState } from '../../../config/redux/types';
import { Accommodation, Property } from '../../../routes/reducers/types';
import { useFetchBookings } from '../../availabilityWidget/api/bookingsApi';

interface AvailabilityRequestContainerProps {
  accommodation: Accommodation;
  property: Property;
}

export default function AvailabilityRequestContainer({
  property,
  accommodation,
}: AvailabilityRequestContainerProps): JSX.Element | null {
  const routes = useSelector((state: RootState) => state.routes);
  const lang = useSelector((state: RootState) => state.routes.locale);
  const { data: bookingsData } = useFetchBookings(lang, property.id);
  const bookings = bookingsData?.calendar;

  if (accommodation == null) {
    return null;
  }
  const minDate = moment();

  return (
    <AvailabilityRequest
      accommodation={accommodation}
      property={property}
      minDate={minDate}
      bookings={bookings || {}}
    />
  );
}
